import MobileDetect from 'mobile-detect'

export function isMobileView() {
  const md = new MobileDetect(window.navigator.userAgent)
  return md.mobile() || window.innerWidth < 1024
}

export const rules = {
  required: (value: string) => !!value || 'Required',
  textLength: (value: string) => {
    if (!value) return true
    else return value.length >= 2 || 'Min 2 characters'
  },
  email: (value: string) => {
    if (!value) return true
    else {
      const pattern = /^[^\s@]+@[^\s@.]+\.[^\s@]+$/
      return pattern.test(value) || 'Invalid Email'
      
    }
  },
  phoneNumber: (value: string) => {
    if (!value) return true
    else {
      value = value.replace(/\s/g, '') // Remove spaces
      const pattern = /^\+?\d{10,15}$/
      return pattern.test(value) || 'Invalid Phone Number'
    }
  },
  maxLength: (max: number) => (value: string) => {
    return (value && value.length <= max) || `Max ${max} characters`
  },
  numericOnly: (value: string) => {
    const pattern = /^[\d,.]+$/
    if (!value)
      return true // Allow null values
    else {
      return pattern.test(value) || 'Only numeric values are allowed'
    }
  },
  specialCharacters: (value: string | null) => {
    if (!value)
      return true // Allow null values
    else {
      const pattern = /^[^<>&'"/_]+$/
      return pattern.test(value) || 'Input contains invalid characters'
    }
  },
  postcode: (value: string | null) => {
    if (!value)
      return true // Allow null values
    else {
      const pattern = /^[A-Za-z0-9\s-]+$/
      return pattern.test(value) || 'Invalid Postcode'
    }
  }
}
